function initLazyload() {
	window.lazySizesConfig = {
		addClasses: true
	};
}